import React from "react";
import { Mail, MessageCircle, ArrowRight } from "lucide-react";
import { useI18n } from "../../i18n";
import { Container, Section, Card } from "../../components/ui/Primitives";
import { Button } from "../../components/ui/Button";
import { PageHero } from "../../components/marketing/Shared";
import { CONTACT_EMAIL, CONTACT_MAILTO, CONTACT_WHATSAPP } from "../../lib/contact";

export default function Contact() {
  const { t } = useI18n();

  return (
    <>
      <PageHero
        breadcrumb={t("nav.contact")}
        eyebrow={t("contact.hero.eyebrow")}
        title={t("contact.hero.title")}
        lead={t("contact.hero.lead")}
      />

      <Section>
        <Container>
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-2xl sm:text-3xl">{t("contact.channels.title")}</h2>
            <p className="mt-3 text-muted-foreground">{t("contact.channels.subtitle")}</p>
          </div>

          {/* Channels — full width, two prominent options */}
          <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2">
            {/* Email */}
            <Card className="flex flex-col p-7">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand/12 text-brand">
                <Mail className="h-6 w-6" />
              </span>
              <h3 className="mt-5 text-lg font-bold">{t("contact.email.title")}</h3>
              <a
                href={CONTACT_MAILTO}
                className="mt-1 break-all font-mono text-sm text-brand hover:underline"
              >
                {CONTACT_EMAIL}
              </a>
              <div className="flex-1" />
              <Button href={CONTACT_MAILTO} className="mt-6 w-full">
                <Mail className="h-4 w-4" /> {t("contact.email.cta")}
              </Button>
            </Card>

            {/* WhatsApp */}
            <Card className="flex flex-col p-7">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-ctf/12 text-ctf">
                <MessageCircle className="h-6 w-6" />
              </span>
              <h3 className="mt-5 text-lg font-bold">{t("contact.whatsapp.title")}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{t("contact.whatsapp.desc")}</p>
              <div className="flex-1" />
              <Button
                href={CONTACT_WHATSAPP}
                target="_blank"
                rel="noopener noreferrer"
                variant="outline"
                className="mt-6 w-full"
              >
                <MessageCircle className="h-4 w-4" /> {t("contact.whatsapp.cta")}
                <ArrowRight className="h-4 w-4" />
              </Button>
            </Card>
          </div>
        </Container>
      </Section>
    </>
  );
}
